import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { EmopPublicWorkflowApprovalApiService } from '../../emop-public-workflow-approval-api.service';
import BpmnModeler from 'bpmn-js/lib/Modeler';
import { EmopPublicWorkflowApprovalService } from '../../emop-public-workflow-approval.service';

class WorkflowTemplate {
  id: number;
  dbVersion: number;
  creator: string;
  creationDate: number;
  lstModifier: string;
  lstmodifiedDate: number;
  name: string;
  processKey: string;
  bpmn20Xml: string;
  state: number;
  version: number;
  domain: string;
  tenantId: string;
}

@Component({
  selector: 'app-emop-public-workflow-approval-detail',
  templateUrl: './emop-public-workflow-approval-detail.component.html',
  styleUrls: ['./emop-public-workflow-approval-detail.component.scss']
})
export class EmopPublicWorkflowApprovalDetailComponent implements OnInit {
  modeler: BpmnModeler;
  workflowTemplate: WorkflowTemplate = new WorkflowTemplate();
  @ViewChild('canvasContainer', { read: ElementRef }) canvasContainer: ElementRef;
  constructor(
    private EmopPublicWorkflowApprovalApiService: EmopPublicWorkflowApprovalApiService,
    private EmopPublicWorkflowApprovalService: EmopPublicWorkflowApprovalService
  ) { }
  nodeStroke = {};
  nodeFill = {};
  _elementColors = {};
  loading = false;

  ngOnInit(): void {
  }
  ngAfterViewInit(): void {
    setTimeout(() => {
      this.initBpmn();
    }, 0);
  }
  initBpmn() {
    this.loading = true;
    this.EmopPublicWorkflowApprovalApiService.processInstanceTrace(this.EmopPublicWorkflowApprovalService.processInstanceId).subscribe(rs => {
      this.modeler = new BpmnModeler({
        container: this.canvasContainer.nativeElement,
        additionalModules: [{
          paletteProvider: ["value", ""],
          labelEditingProvider: ["value", ""],
          contextPadProvider: ["value", ""],
          bendpoints: ["value", ""],
          move: ["value", ""],
        }]
      });
      rs.data.forEach(item => {
        if (!!item.endTime) {
          this.nodeFill[item.activityId] = '#e1f5fe';
          this.nodeStroke[item.activityId] = '#0277bd';
          this.nodeFill[item.activityId + '_label'] = '#e1f5fe';
          this.nodeStroke[item.activityId + '_label'] = '#0277bd';
        } else {
          this.nodeFill[item.activityId] = '#e8f5e9';
          this.nodeStroke[item.activityId] = '#558b2f';
          this.nodeFill[item.activityId + '_label'] = '#e8f5e9';
          this.nodeStroke[item.activityId + '_label'] = '#558b2f';
        }
      });
      this.EmopPublicWorkflowApprovalApiService.getXml(this.EmopPublicWorkflowApprovalService.processInstanceId).subscribe(rs => {
        this.importXML(rs.data);
        this.loading = false;
      });
    });
  }
  importXML(xml: string): void {
    this.workflowTemplate.bpmn20Xml = xml;
    this.modeler.importXML(this.workflowTemplate.bpmn20Xml);
    this.preserveColors();
    // 修改页面顶部流程名
    setTimeout(() => {
      this.workflowTemplate.name = this.modeler._definitions.rootElements[0].name;
      this.preserveColors();
    }, 0);
  }
  preserveColors(): void {
    this.modeler.get('elementRegistry').forEach(element => {
      this._elementColors[element.id] = {
        stroke: element.businessObject.di.get('stroke'),
        fill: element.businessObject.di.get('fill')
      };
      if (!!this.nodeStroke[element.id]) {
        this.setColor(element, this.nodeStroke[element.id], this.nodeFill[element.id]);
      } else if (element.type === 'bpmn:SequenceFlow' &&
        !!this.nodeStroke[element.businessObject.sourceRef.id] &&
        !!this.nodeStroke[element.businessObject.targetRef.id]) {
        this.setColor(element, this.nodeStroke[element.businessObject.targetRef.id],
          this.nodeFill[element.businessObject.sourceRef.id]);
      } else {
        this.setColor(element, '#424242', '#fafafa');
      }
    });
  }

  setColor(element, stroke, fill): void {
    const businessObject = element.businessObject;
    businessObject.di.set('stroke', stroke);
    businessObject.di.set('fill', fill);

    const gfx = this.modeler.get('elementRegistry').getGraphics(element);
    const type = element.waypoints ? 'connection' : 'shape';
    this.modeler.get('graphicsFactory').update(type, element, gfx);
    // setTimeout(() => {
    //   this.modeler.get('canvas').zoom('fit-viewport');
    // }, 0);
  }
  zoom($event: number): void {
    this.modeler.get('canvas').zoom($event / 100);
  }
}
